const API_BASE = "/api";

function getToken() {
  return localStorage.getItem("admin_token");
}

async function request(path, options = {}) {
  const headers = { ...(options.headers || {}) };

  if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  const token = getToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || "Request failed");
  }

  return data;
}

export const api = {
  login(email, password) {
    return request("/auth/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    });
  },

  me() {
    return request("/auth/me");
  },

  getNews() {
    return request("/news");
  },

  getNewsItem(id) {
    return request(`/news/${id}`);
  },

  createNews(payload) {
    return request("/news", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  updateNews(id, payload) {
    return request(`/news/${id}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  },

  deleteNews(id) {
    return request(`/news/${id}`, { method: "DELETE" });
  },

  uploadImage(file) {
    const formData = new FormData();
    formData.append("file", file);
    return request("/upload", {
      method: "POST",
      body: formData,
    });
  },
};

export { getToken };
